import React, { Component } from "react";

const ScreenSize = (WrappedComponent) => {
	class ScreenSizeHOC extends Component {
		constructor(props) {
			super(props);
			this.state = {
				width: window.innerWidth
			};
		}
	
		componentDidMount() {
			window.addEventListener("resize", this.handleWindowSizeChange);
		}
	
		componentWillUnmount() {
			window.removeEventListener("resize", this.handleWindowSizeChange);
		}
	
		handleWindowSizeChange = () => {
			this.setState({ width: window.innerWidth });
		};
		
		render() {
			const { width } = this.state;
			const isMobile = width <= 968;
			return (
				<WrappedComponent
					{...this.props}
					isMobile={isMobile}
				/>
			);
		}
	}
	return ScreenSizeHOC;
  };
  
  export default ScreenSize;